module.exports = __webpack_public_path__ + "1-06.png?96b6bcb5ac1580ec35005ad4ef6f282b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-06.png
// module id = 83
// module chunks = 0